var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { SvgIcon } from '@mui/material';
function CartIconInner(props) {
    return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 1C1.44772 1 1 1.44772 1 2C1 2.55228 1.44772 3 2 3H3.14551L5.9456 20.7339C6.06072 21.463 6.68914 22 7.42725 22H19C19.5523 22 20 21.5523 20 21C20 20.4477 19.5523 20 19 20H7.85449L7.5387 18H18.3308C19.7807 18 21.0231 16.9631 21.2825 15.5367L22.8767 6.76833C23.0441 5.84757 22.3368 5 21.4009 5H5.48607L5.0544 2.26606C4.93928 1.53698 4.31086 1 3.57275 1H2ZM5.80186 7L7.22292 16H18.3308C18.8141 16 19.2283 15.6544 19.3147 15.1789L20.8018 7H5.80186Z", fill: "" })));
}
export var CartIcon = function (props) { return (React.createElement(SvgIcon, __assign({ inheritViewBox: true, component: CartIconInner }, props))); };
//# sourceMappingURL=CartIcon.js.map